module.exports = __webpack_public_path__ + "a58589b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/Pediatria/10540.jpg
// module id = 1321
// module chunks = 0 1